// components/SearchBox.js
import { useNavigate } from 'react-router-dom';
import Input from './ui/Input';
import React, { useState, useEffect } from "react";
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import Profile from './Profile';
import Notification from './Notification';

const SearchBox = ({ onSearch, initialQuery }) => {

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New book added to your course", read: false },
    { id: 2, message: "Your library subscription expires soon", read: false }
  ]);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const unreadCount = notifications.filter((n) => !n.read).length;

  const [username, setUsername] = useState(null); // Store the username
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [courseIds, setCourseIds] = useState(null); // Store the username
  const [collegeId, setCollegeId] = useState(null); // Store the username
  const [inputValue, setInputValue] = useState(initialQuery || '');
  const navigate = useNavigate();
  

  const handleSearch = () => {
    const query = inputValue.trim();
    if (!query) return alert("Please enter a search term.");
    navigate(`/journal_articles?query=${encodeURIComponent(query)}`, {
      state: { query }
    });
  };

  const handleClear = () => {
    setInputValue('');
  };
    
      const handleLogout = () => {
        // Clear the token and user from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    
        // Redirect the user to the login page
        navigate('/');
      };

  return (

<div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">

  <div className="relative w-full max-w-lg">
                  <Input
                    placeholder="Search journal articles..."
                    className="pl-10"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') handleSearch();
                    }}
                  />
    <FaSearch className="absolute left-3 top-3 text-gray-500" />
    {inputValue && (
      <button
        onClick={handleClear}
        className="absolute right-3 top-2 text-gray-500 hover:text-gray-700"
        aria-label="Clear search"
      >
        ✕
      </button>
    )}
  </div>

  <div className="flex items-center space-x-4 relative">
    <Notification />
    <Profile />
  </div>
</div>

  );
};

export default SearchBox;
